// extracted by mini-css-extract-plugin
export default {"groupParent":"FAQs_groupParent__y8YIk","title":"FAQs_title__fClKR","contentFaqs":"FAQs_contentFaqs__FxqLa"};